function MessageItemCard() {
    return (
        <div>Hello this is message item</div>
    );
}

export default MessageItemCard;
